export default "__VITE_ASSET__CC5XlfuK__"